var oldStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = function() {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(7336);
	}
	return oldStartup();
};